import React from 'react';
import styles from './styles.module.scss';
import { formatCurrency } from '@wolffun/system-currency';
import Button from 'src/Components/Button_V2';
import { StakingPlan } from 'src/models';

const ConfirmStake = ({
  numberSelected,
  totalPrice,
  planStake,
  thgBalance,
  showStakeForm,
  doHigherRewardStake
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.confirm
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Confirmation"), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.item
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Heroes Selected"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, numberSelected)), /*#__PURE__*/React.createElement("div", {
    className: styles.item
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Staking Amount"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, formatCurrency(totalPrice, {
    withCurrency: true,
    trimWholeFraction: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.item
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Staking Plan"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, planStake == StakingPlan.SIX_MONTHS ? '6 months' : '12 months')), /*#__PURE__*/React.createElement("div", {
    className: styles.item
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, "Your Balance"), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, thgBalance && formatCurrency(thgBalance, {
    withCurrency: true,
    trimWholeFraction: true,
    precision: 2
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.notice
  }, /*#__PURE__*/React.createElement("span", null, "Once NFT heroes are staked, they will be removed from your inventory permanently.")), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    title: "Back",
    type: "secondary",
    className: styles.btn,
    onClick: showStakeForm
  }), /*#__PURE__*/React.createElement(Button, {
    title: "Confirm",
    type: "warning",
    className: styles.btn,
    onClick: doHigherRewardStake
  })));
};

export default ConfirmStake;